import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_SERVICE_GROUPS = "fetchServiceGroups";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingServiceMachine";

const state = {
  errors: [],
  isLoadingServiceMachine: false
};

const getters = {
  isLoadingServiceGroup() {
    return state.isLoadingServiceGroup;
  }
};

const actions = {
  [FETCH_SERVICE_GROUPS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-groups" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingServiceGroup = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingServiceGroup = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
